jQuery(function($){
    var MODAL_ID = '#imgModal';

    function ensureModal(){
        if (!$(MODAL_ID).length){
        $('body').append(`
            <div id="imgModal" class="img-modal">
            <button class="img-modal-close" aria-label="Close">&times;</button>
            <div class="img-modal-inner">
                <img class="img-modal-img" src="" alt="">
            </div>
            </div>
        `);
        }
        return $(MODAL_ID);
    }

    $('.section-image-gallery .image-gallery').on('click','div img',function(){
        var full = $(this).attr('data-full-size');
        if (!full) return;

        var $modal = ensureModal();
        var $img   = $modal.find('.img-modal-img');
        var $close = $modal.find('.img-modal-close');

        $modal.fadeIn(120);

        $img.css('opacity',0).attr('src',''); // clear old
        $close.hide(); // hide X while loading

        var loader = new Image();
        loader.onload = function(){
        $img.attr('src', full).css('opacity',1);
        $close.show();
        };
        loader.src = full;
    });

    $('body').on('click','#imgModal, .img-modal-close',function(e){
        if (e.target === this || $(e.target).is('.img-modal-close')) $('#imgModal').fadeOut(120);
    });

    $('body').on('click', '.img-modal-inner', function(e) {
    if (!$(e.target).is('.img-modal-img')) {
        $('#imgModal').fadeOut(120);
    }
    });

    $(document).on('keydown',function(e){
        if (e.key === 'Escape') $('#imgModal').fadeOut(120);
    });

  $(document).on('click', '.expand-gallery', function(e){
    e.preventDefault();

    $(this).parent().prev().removeClass('gallery-closed');

    $(this)
      .parent()
      .prev('.image-gallery')
      .slideDown();
  });

});

